export default {
  state: {
    currencies: [],
    loading: false,
  },
  getters: {
    currencies: state => state.currencies,
    loading: state => state.loading,
  },
  mutations: {
    setCurrencies(state, currencies) {
      state.currencies = currencies;
    },
    setLoading(state, display) {
      state.loading = display;
    }
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const currencies = await axios.get('api/currencies');
        commit('setCurrencies', currencies);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      try {
        return await axios.get('api/currencies/' + id);
      } catch (e) {
      }
    },

    async add({ commit }, payLoad) {
        await axios.post('api/currencies', payLoad);
    },

    async update({ commit }, payLoad) {
        await axios.put('api/currencies', payLoad);
    },

    async delete({}, id) {
      await axios.delete('api/currencies/' + id);
    }
  },
};
